import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CenterToastMessage = ({ message, severity, open, handleClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Position it at the top right
      sx={{
        "& .MuiSnackbarContent-root": {
          display: 'flex',
          justifyContent: 'center',  // Center the message content
        },
      width:700,borderRadius:"10px", // Adjust this value to move the snackbar higher or lower
      }}
    >
      <Alert onClose={handleClose} severity={severity}   sx={{
          backgroundColor: '#FEF2F2', // Set the background color to #FEF2F2
          color: 'red', 
         width:700,padding:"10px 10px",display:"flex",justifyContent:'center',font:'inter',borderRadius:"10px"
        }}>
      <ErrorOutlineIcon sx={{marginBottom:'5px'}}/>  {message}
      </Alert>
    </Snackbar>
  );
};

export default CenterToastMessage;
